/*
  assets/oim-su-misura.js — abbinamenti di colore che si danno il cambio (sections/oim-su-misura.liquid).
  Ogni 3,5 s; la seconda colonna parte sfalsata di mezzo giro. Si ferma con il mouse sopra o il fuoco
  dentro la colonna, a scheda nascosta, col pulsante di pausa o toccando un pallino (quella colonna sola).
  Con «riduci movimento» o nell'editor del tema non gira: restano i pallini, e il pulsante resta nascosto.
*/
(function () {
  if (window.oimSuMisura) return;
  window.oimSuMisura = true;
  var T = 3500;
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches || !!(window.Shopify && Shopify.designMode);

  function init(el) {
    if (el.dataset.oimReady) return;
    el.dataset.oimReady = '1';
    var imgs = el.querySelectorAll('.oim-sm__img');
    var dots = el.querySelectorAll('.oim-sm__dot');
    var n = imgs.length;
    if (n < 2) return;
    var names = [];
    try { names = JSON.parse(el.dataset.names || '[]'); } catch (e) { names = []; }
    var now = el.querySelector('.oim-sm__nowname');
    var pb = el.querySelector('.oim-sm__pause');
    var i = 0, paused = still, hover = false;

    function show(k) {
      i = (k + n) % n;
      for (var j = 0; j < n; j++) {
        imgs[j].classList.toggle('is-on', j === i);
        if (j === i) imgs[j].removeAttribute('aria-hidden'); else imgs[j].setAttribute('aria-hidden', 'true');
      }
      for (var d = 0; d < dots.length; d++) dots[d].setAttribute('aria-pressed', d === i ? 'true' : 'false');
      if (now && names[i]) now.textContent = names[i];
    }
    function sync() {
      if (!pb) return;
      pb.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pb.setAttribute('aria-label', paused ? el.dataset.play : el.dataset.pause);
    }

    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function (e) {
        paused = true; sync(); show(+e.currentTarget.dataset.i);
      });
    }
    if (still) return;

    el.addEventListener('mouseenter', function () { hover = true; });
    el.addEventListener('mouseleave', function () { hover = false; });
    el.addEventListener('focusin', function () { hover = true; });
    el.addEventListener('focusout', function () { hover = false; });
    if (pb) {
      pb.hidden = false;
      pb.addEventListener('click', function () { paused = !paused; sync(); });
    }
    sync();
    setTimeout(function () {
      setInterval(function () {
        if (!paused && !hover && !document.hidden) show(i + 1);
      }, T);
    }, (+el.dataset.delay || 0) * T / 2);
  }

  function all() {
    var els = document.querySelectorAll('[data-oim-rotor]');
    for (var k = 0; k < els.length; k++) init(els[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
